/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Empty_State_Hint_SearchInputs */



/**
* | output |
* | --- |
* | "Try adjusting your search or filters" |
*
* @param {Manual_Qc_Empty_State_Hint_SearchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_empty_state_hint_search = /** @type {((inputs?: Manual_Qc_Empty_State_Hint_SearchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Empty_State_Hint_SearchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Essayez de modifier votre recherche ou vos filtres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Versuchen Sie, Ihre Suche oder Filter anzupassen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prova a modificare la tua ricerca o i filtri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Попробуйте изменить параметры поиска или фильтры.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Intente ajustar su búsqueda o filtros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("尝试调整搜索或筛选条件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("検索条件やフィルターを調整してみてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपनी खोज या फ़िल्टर को समायोजित करने का प्रयास करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tente ajustar sua pesquisa ou filtros.")
	return /** @type {LocalizedString} */ ("Try adjusting your search or filters")
});